import { isPermissionGranted } from "@utils/CommonUtil";

export const DEVICE_PERMISSION_LABEL_KEYS: Record<string, string> = {
  eyeTracking: "OrganizationSettings.permissionEyeTracking",
  writeExternalStorage: "OrganizationSettings.permissionWriteExternalStorage",
  writeSettings: "OrganizationSettings.permissionWriteSettings",
  secureSettings: "OrganizationSettings.permissionWriteSecureSettings",
};

export function normalizeDevicePermissions(
  permissions: Record<string, unknown>,
): Record<string, boolean> {
  return Object.fromEntries(
    Object.entries(permissions).map(([key, value]) => [key, isPermissionGranted(value)]),
  );
}

export function hasUngrantedDevicePermission(
  permissions?: Record<string, unknown> | null,
): boolean {
  if (!permissions) return false;
  return Object.values(permissions).some((value) => !isPermissionGranted(value));
}
